import { render } from "./AllIntensiveCares.vue?vue&type=template&id=874a4912&scoped=true"
import script from "./AllIntensiveCares.vue?vue&type=script&lang=js"
export * from "./AllIntensiveCares.vue?vue&type=script&lang=js"

import "./AllIntensiveCares.vue?vue&type=style&index=0&id=874a4912&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-874a4912"]])

export default __exports__